export default __webpack_public_path__ + "static/media/portal.96dea0e4.svg";